// extracted by mini-css-extract-plugin
export default {"container":"apartment1slides_container__M3e2r"};